// extracted by mini-css-extract-plugin
export default {"partners":"style_partners__hziVG"};